import React, { Component } from 'react';
import './ExtensionDetector.scss';

class ExtensionDetector extends Component { 
    constructor(props) {
        super(props);   
        this.state = {
            installed : false,
            open : false,
            data : 'loading'
        }    
    }
    componentDidMount () {
        // ready
        setTimeout(function(){
            //this.handleChrome();
        }.bind(this), 1000)
        

    }
    handleChrome = () => {
        const data = { sender: 'PAGE', request: "IS_INSTALLED"};
        window.postMessage(data, "*");
        
        window.addEventListener("message", function(event) {
            // We only accept messages from ourselves
            if (event.source != window)
                return;
            
            if (event.data.sender === 'EXT') {
                if (event.data.installed) {
                    console.log("extension installed: " + event.data.installed);
                    setInterval(function(){
                        this.handleExtension();
                    }.bind(this), 1000)
                    this.setState({
                        installed : event.data.installed
                    }) 
                }
                if (event.data.data) {
                    console.log(event.data.payload);
                    
                    this.setState({
                        data : event.data.payload
                    })
                }
            }
        }.bind(this));
        

    }
    handleExtension = () => {
        let _inDom = document.getElementById("__klue_frame__");
        
        if (_inDom && !this.state.open) {
            setTimeout(function(){
                this.handleFetchData();
            }.bind(this), 5000)
        }
            
        
        this.setState({
            open : _inDom
        })
    }
    handleFetchData = () => {
        const data = { sender: 'PAGE', request: "FETCH_DATA"};
        window.postMessage(data, "*");
        
    }
    render () {
        let _installed = this.state.installed,
            _open = this.state.open,
            _data = this.state.data;
        return (
            <div class="ExtensionDetector">
                { !_installed && 
                    <div>extension not installed</div>
                }
                { (_installed && !_open) &&
                    <div>extension installed</div>
                }
                { (_installed && _open) &&
                    <div>{ _data }</div>
                }
            </div>
        );
    }
}

export default ExtensionDetector;